var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { _transformBid } from '@freelancer/datastore/bids';
import { _transformCurrency } from '@freelancer/datastore/currencies';
import { _transformDeloitteProjectDetails } from '@freelancer/datastore/deloitte';
import { EnterpriseApi } from 'api-typings/common/common';
export function transformProject(project, selectedBidsList) {
    var selectedBids = selectedBidsList ? selectedBidsList[project.id] : [];
    return __assign({}, transformBaseProject(project), { selectedBids: selectedBids ? selectedBids.map(_transformBid) : [], files: project.files });
}
export function transformBaseProject(project) {
    if (!project.bid_stats ||
        !project.budget ||
        !project.currency ||
        !project.seo_url ||
        !project.time_submitted ||
        !project.type) {
        throw new ReferenceError("Missing a required project field.");
    }
    return {
        id: project.id,
        bidPeriod: project.bidperiod,
        bidStats: transformBidStats(project.bid_stats),
        budget: transformProjectBudget(project.budget),
        currency: _transformCurrency(project.currency),
        deleted: project.deleted,
        frontendProjectStatus: project.frontend_project_status,
        hideBids: project.hidebids,
        hireme: project.hireme || false,
        hourlyProjectInfo: project.hourly_project_info
            ? transformProjectHourlyProjectInfo(project.hourly_project_info)
            : undefined,
        language: project.language || 'en',
        local: project.local || false,
        ownerId: project.owner_id,
        previewDescription: project.preview_description || '',
        projectCollaborations: (project.project_collaborations || []).map(transformProjectCollaborations),
        seoUrl: project.seo_url,
        status: project.status,
        subStatus: project.sub_status,
        timeSubmitted: project.time_submitted * 1000,
        title: project.title,
        type: project.type,
        upgrades: project.upgrades
            ? transformProjectUpgrades(project.upgrades)
            : emptyProjectUpgrades(),
        poolIds: project.pool_ids,
        enterpriseIds: project.enterprise_ids,
        deloitteDetails: project.deloitte_details
            ? _transformDeloitteProjectDetails(project.deloitte_details)
            : undefined,
        timeframe: project.timeframe
            ? transformTimeframe(project.timeframe)
            : undefined,
        isEscrowProject: project.is_escrow_project,
        isSellerKycRequired: project.is_seller_kyc_required,
        isBuyerKycRequired: project.is_buyer_kyc_required,
        isDeloitteProject: project.enterprise_ids
            ? project.enterprise_ids.includes(EnterpriseApi.DELOITTE_DC)
            : false,
        isTokenProject: project.currency.code === 'TKN',
        isArrowProject: project.enterprise_ids
            ? project.enterprise_ids.includes(EnterpriseApi.ARROW)
            : false,
    };
}
export function transformTimeframe(timeframe) {
    return {
        startDate: timeframe.start_date ? timeframe.start_date * 1000 : undefined,
        endDate: timeframe.end_date ? timeframe.end_date * 1000 : undefined,
    };
}
export function transformBidStats(bidStats) {
    return {
        bidCount: bidStats.bid_count || 0,
        bidAvg: Math.ceil(bidStats.bid_avg || 0),
    };
}
export function transformProjectBudget(budget) {
    return {
        minimum: budget.minimum,
        maximum: budget.maximum,
        name: budget.name,
        projectType: budget.project_type,
        currencyId: budget.currency_id,
    };
}
export function transformProjectHourlyProjectInfo(info) {
    return {
        commitment: info.commitment,
        durationEnum: info.duration_enum,
    };
}
function transformProjectCollaborations(collaboration) {
    if (!collaboration.id) {
        throw new ReferenceError("Missing project collaboration id.");
    }
    return {
        context: collaboration.context,
        contextOwnerId: collaboration.context_owner_id,
        id: collaboration.id,
        permissions: collaboration.permissions || [],
        status: collaboration.status,
        timeCreated: (collaboration.time_created || 0) * 1000,
        userId: collaboration.user_id,
    };
}
export function transformProjectUpgrades(upgrades) {
    return {
        assisted: upgrades.assisted || false,
        featured: upgrades.featured || false,
        fulltime: upgrades.fulltime || false,
        ipContract: upgrades.ip_contract || false,
        listed: upgrades.listed || false,
        NDA: upgrades.NDA || false,
        nonpublic: upgrades.nonpublic || false,
        projectManagement: upgrades.project_management || false,
        qualified: upgrades.qualified || false,
        sealed: upgrades.sealed || false,
        urgent: upgrades.urgent || false,
        extend: upgrades.extend || false,
    };
}
export function emptyProjectUpgrades() {
    return {
        assisted: false,
        featured: false,
        fulltime: false,
        ipContract: false,
        listed: false,
        NDA: false,
        nonpublic: false,
        projectManagement: false,
        qualified: false,
        sealed: false,
        urgent: false,
        extend: false,
    };
}
